<div class="main-content">

  <!-- ─── HEADER (stesso design di /damage-overview e /damage-overview/create) ─── -->
  <div class="header-section">
    <div class="wm-heading">
      <div class="wm-heading-icon wm-heading-icon--orange">
        <i class="fas fa-folder-open"></i>
      </div>
      <div>
        <h1 class="main-title">Gestione Pratica Danno</h1>
        <p class="main-subtitle" *ngIf="damage">
          Pratica <span class="dd-code">{{ damage.damageCode || ('#' + damage.damageId) }}</span>
          <ng-container *ngIf="damage.damageParcelCode">
            per il collo <span class="dd-code">{{ damage.damageParcelCode }}</span>
          </ng-container>
        </p>
        <p class="main-subtitle" *ngIf="!damage && isLoading">Caricamento della pratica #{{ damageId }}...</p>
        <p class="main-subtitle" *ngIf="!damage && !isLoading">Pratica #{{ damageId }}</p>
      </div>
    </div>

    <!-- Utente collegato e collegamenti alle pagine della gestione danni -->
    <app-damage-nav-box></app-damage-nav-box>

    <!-- Strumentario -->
    <div class="toolbox-container">
      <div class="toolbox-heading">
        <div class="toolbox-heading-icon">
          <i class="fas fa-tools"></i>
        </div>
        <div class="toolbox-heading-text">
          <span class="toolbox-title">Strumentario</span>
          <small class="toolbox-subtitle">Strumenti rapidi</small>
        </div>
      </div>
      <div class="toolbox-divider"></div>
      <div class="toolbox-buttons">
        <button type="button" class="toolbox-btn toolbox-btn--green" (click)="loadDamageDetail()"
                [disabled]="isLoading" title="Ricarica la pratica">
          <i class="fas fa-sync-alt" [class.fa-spin]="isLoading"></i>
        </button>
        <button type="button" class="toolbox-btn toolbox-btn--purple" (click)="printReport()"
                [disabled]="!damage || isLoading" title="Stampa la pagina">
          <i class="fas fa-print"></i>
        </button>
        <!-- PDF della scheda pratica generato dal backend (template damages-template, stessa stampa delle bolle) -->
        <button type="button" class="toolbox-btn toolbox-btn--red" (click)="downloadReportPdf()"
                [disabled]="!damage || isLoading || isPrintingPdf" title="Scarica il PDF della pratica danno">
          <i class="fas" [ngClass]="isPrintingPdf ? 'fa-spinner fa-spin' : 'fa-file-pdf'"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- ─── CARICAMENTO ─── -->
  <div class="card mb-4" *ngIf="isLoading">
    <div class="card-body">
      <div class="dd-skeleton">
        <div class="dd-skeleton-line dd-skeleton-line--title"></div>
        <div class="dd-skeleton-grid">
          <div class="dd-skeleton-line" *ngFor="let i of [].constructor(8)"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- ─── PRATICA NON TROVATA ─── -->
  <div class="card mb-4" *ngIf="!isLoading && notFound">
    <div class="card-body">
      <div class="empty-state text-center">
        <div class="empty-state-icon mb-3">
          <i class="fas fa-folder-open fa-3x text-muted"></i>
        </div>
        <h5 class="empty-state-title text-muted mb-2">Pratica danno non trovata</h5>
        <p class="empty-state-subtitle text-muted small mb-3">
          Nessuna pratica con id <strong>#{{ damageId }}</strong>. Potrebbe essere stata rimossa o il collegamento non è valido.
        </p>
        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="backToList()">
          <i class="fas fa-arrow-left me-1"></i> Torna all'elenco
        </button>
      </div>
    </div>
  </div>

  <!-- ─── ERRORE DI CARICAMENTO ─── -->
  <div class="card mb-4" *ngIf="!isLoading && !notFound && errorMessage">
    <div class="card-body">
      <div class="empty-state text-center">
        <div class="empty-state-icon mb-3">
          <i class="fas fa-exclamation-circle fa-3x text-danger"></i>
        </div>
        <h5 class="empty-state-title text-muted mb-2">Errore nel caricamento della pratica</h5>
        <p class="empty-state-subtitle text-muted small mb-3">{{ errorMessage }}</p>
        <button type="button" class="btn btn-primary btn-sm" (click)="loadDamageDetail()">
          <i class="fas fa-redo-alt me-1"></i> Riprova
        </button>
      </div>
    </div>
  </div>

  <ng-container *ngIf="damage && !isLoading">

    <!-- ─── SEZIONE 1: RIEPILOGO ─── -->
    <div class="card mb-4">
      <div class="card-header">
        <div class="header-title">
          <i class="fas fa-chart-bar header-icon"></i>
          <h3>Riepilogo</h3>
        </div>
      </div>
      <div class="card-body">
        <div class="dmg-metrics-grid">

          <div class="dmg-metric-card">
            <div class="dmg-metric-icon" [ngClass]="statusIconClass">
              <i class="fas" [ngClass]="isClosed ? 'fa-check-circle' : 'fa-hourglass-half'"></i>
            </div>
            <div class="dmg-metric-body">
              <div class="dmg-metric-value dmg-metric-value--badge">
                <span class="dmg-badge" [ngClass]="statusBadgeClass">
                  {{ damage.damageStatus ? ('DAMAGES.STATUS.' + damage.damageStatus | translate) : '-' }}
                </span>
              </div>
              <div class="dmg-metric-label">Stato pratica</div>
            </div>
          </div>

          <div class="dmg-metric-card">
            <div class="dmg-metric-icon dmg-metric-icon--red">
              <i class="fas fa-exclamation-triangle"></i>
            </div>
            <div class="dmg-metric-body">
              <div class="dmg-metric-value dmg-metric-value--badge">
                <span class="dmg-badge" [ngClass]="severityBadgeClass">
                  {{ damage.damageSeverity ? ('DAMAGES.SEVERITY.' + damage.damageSeverity | translate) : '-' }}
                </span>
              </div>
              <div class="dmg-metric-label">Gravità</div>
            </div>
          </div>

          <div class="dmg-metric-card">
            <div class="dmg-metric-icon dmg-metric-icon--orange">
              <i class="fas fa-tag"></i>
            </div>
            <div class="dmg-metric-body">
              <div class="dmg-metric-value dmg-metric-value--text">
                {{ damage.damageType ? ('DAMAGES.TYPE.' + damage.damageType | translate) : '-' }}
              </div>
              <div class="dmg-metric-label">Tipo danno</div>
            </div>
          </div>

          <div class="dmg-metric-card">
            <div class="dmg-metric-icon dmg-metric-icon--yellow">
              <i class="fas fa-flag"></i>
            </div>
            <div class="dmg-metric-body">
              <div class="dmg-metric-value">{{ damage.damagePriority ?? '-' }}</div>
              <div class="dmg-metric-label">Priorità</div>
            </div>
          </div>

          <div class="dmg-metric-card">
            <div class="dmg-metric-icon dmg-metric-icon--purple">
              <i class="fas fa-stream"></i>
            </div>
            <div class="dmg-metric-body">
              <div class="dmg-metric-value">{{ events.length }}</div>
              <div class="dmg-metric-label">Eventi registrati</div>
            </div>
          </div>

          <div class="dmg-metric-card">
            <div class="dmg-metric-icon dmg-metric-icon--green">
              <i class="fas fa-euro-sign"></i>
            </div>
            <div class="dmg-metric-body">
              <div class="dmg-metric-value">{{ amounts.length }}</div>
              <div class="dmg-metric-label">Importi registrati</div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- ─── SEZIONE 2: DATI DELLA PRATICA ─── -->
    <!-- Un'unica card divisa in sottosezioni (dd-subsection): Riferimenti,
         Spedizione, Classificazione, Rilevamento, Gestione, Chiusura. Ogni
         campo usa il template fieldTpl in fondo al file: etichetta, icona,
         valore in sola lettura e bottone di copia negli appunti. -->
    <div class="card mb-4">
      <div class="card-header">
        <div class="header-title">
          <i class="fas fa-folder-open header-icon"></i>
          <h3>Pratica Danno</h3>
        </div>
      </div>
      <div class="card-body">

        <!-- Riferimenti -->
        <div class="dd-subsection">
          <div class="dd-subsection-header">
            <span class="dd-subsection-icon"><i class="fas fa-link"></i></span>
            <h6 class="dd-subsection-title">Riferimenti</h6>
          </div>
          <div class="row g-3">
            <div class="col-md-3">
              <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Codice Pratica', icon: 'fa-folder', key: 'damageCode', value: damage.damageCode, mono: true }"></ng-container>
            </div>
            <div class="col-md-3">
              <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Codice Collo', icon: 'fa-box', key: 'damageParcelCode', value: damage.damageParcelCode, mono: true }"></ng-container>
            </div>
            <div class="col-md-3">
              <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Codice Bolla', icon: 'fa-barcode', key: 'damageWaybillCode', value: damage.damageWaybillCode, mono: true }"></ng-container>
            </div>
            <div class="col-md-3">
              <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Cliente', icon: 'fa-users', key: 'damageClientCode', value: clientName, sub: codeNote(clientName, damage.damageClientCode) }"></ng-container>
            </div>
            <div class="col-md-3">
              <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Brand', icon: 'fa-tag', key: 'damageBrandCode', value: brandName, sub: codeNote(brandName, damage.damageBrandCode) }"></ng-container>
            </div>
            <div class="col-md-3">
              <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Dealer', icon: 'fa-store', key: 'damageDealerCode', value: dealerName, sub: codeNote(dealerName, damage.damageDealerCode) }"></ng-container>
            </div>
            <div class="col-md-3">
              <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Corriere', icon: 'fa-truck', key: 'damageCarrierCode', value: carrierName, sub: codeNote(carrierName, damage.damageCarrierCode) }"></ng-container>
            </div>
            <div class="col-md-3">
              <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'ID Giro', icon: 'fa-route', key: 'damageTourRoutingId', value: damage.damageTourRoutingId }"></ng-container>
            </div>
          </div>
        </div>

        <!-- Spedizione: dati della bolla, del collo e del dealer risolti dal backend -->
        <ng-container *ngIf="waybill || parcel || dealer">
          <div class="dd-subsection">
            <div class="dd-subsection-header">
              <span class="dd-subsection-icon"><i class="fas fa-shipping-fast"></i></span>
              <h6 class="dd-subsection-title">Spedizione</h6>
            </div>
            <div class="row g-3">
              <div class="col-md-3">
                <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Data bolla', icon: 'fa-calendar-alt', key: 'waybillDate', value: (waybill?.waybillDate | date:'dd/MM/yyyy HH:mm') }"></ng-container>
              </div>
              <div class="col-md-3">
                <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Stato bolla', icon: 'fa-info-circle', key: 'waybillStatus', value: waybill?.waybillStatus }"></ng-container>
              </div>
              <div class="col-md-3">
                <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Spedizione', icon: 'fa-dolly', key: 'waybillShipmentCode', value: waybill?.waybillShipmentCode, mono: true }"></ng-container>
              </div>
              <div class="col-md-3">
                <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Tracking', icon: 'fa-map-signs', key: 'waybillTrackingNumber', value: waybill?.waybillTrackingNumber, mono: true }"></ng-container>
              </div>
              <div class="col-md-3">
                <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Consegna prevista', icon: 'fa-calendar-check', key: 'waybillEstimatedDeliveryDate', value: (waybill?.waybillEstimatedDeliveryDate | date:'dd/MM/yyyy HH:mm') }"></ng-container>
              </div>
              <div class="col-md-3">
                <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Consegna effettiva', icon: 'fa-calendar-day', key: 'waybillActualDeliveryDate', value: (waybill?.waybillActualDeliveryDate | date:'dd/MM/yyyy HH:mm') }"></ng-container>
              </div>
              <div class="col-md-3">
                <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Metodo consegna', icon: 'fa-truck-loading', key: 'waybillDeliveryMethod', value: waybill?.waybillDeliveryMethod }"></ng-container>
              </div>
              <div class="col-md-3">
                <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Tipo consegna', icon: 'fa-route', key: 'waybillDeliveryType', value: waybill?.waybillDeliveryType }"></ng-container>
              </div>
              <div class="col-md-3">
                <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Origine', icon: 'fa-map-marker-alt', key: 'waybillOriginLocation', value: waybill?.waybillOriginLocation }"></ng-container>
              </div>
              <div class="col-md-3">
                <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Destinazione', icon: 'fa-flag-checkered', key: 'waybillDestinationLocation', value: waybill?.waybillDestinationLocation }"></ng-container>
              </div>
              <div class="col-md-3">
                <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Peso collo (kg)', icon: 'fa-weight', key: 'parcelWeight', value: parcel?.parcelWeight != null ? (parcel?.parcelWeight | number:'1.0-3') : null }"></ng-container>
              </div>
              <div class="col-md-3">
                <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Volume collo (m³)', icon: 'fa-cube', key: 'parcelVolume', value: parcel?.parcelVolume != null ? (parcel?.parcelVolume | number:'1.0-3') : null }"></ng-container>
              </div>
              <div class="col-md-3">
                <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Data collo', icon: 'fa-calendar-alt', key: 'parcelDate', value: (parcel?.parcelDate | date:'dd/MM/yyyy HH:mm') }"></ng-container>
              </div>
              <div class="col-md-3">
                <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Descrizione collo', icon: 'fa-box-open', key: 'parcelDescription', value: parcel?.parcelDescription }"></ng-container>
              </div>
              <div class="col-md-6">
                <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Indirizzo dealer', icon: 'fa-map-marked-alt', key: 'dealerAddress', value: dealerAddress }"></ng-container>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Classificazione -->
        <div class="dd-subsection">
          <div class="dd-subsection-header">
            <span class="dd-subsection-icon"><i class="fas fa-layer-group"></i></span>
            <h6 class="dd-subsection-title">Classificazione</h6>
          </div>
          <div class="row g-3">
            <div class="col-md-3">
              <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Stato', icon: 'fa-circle', key: 'damageStatus', value: damage.damageStatus ? ('DAMAGES.STATUS.' + damage.damageStatus | translate) : null, ops: ['status', 'close'] }"></ng-container>
            </div>
            <div class="col-md-3">
              <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Tipo danno', icon: 'fa-tag', key: 'damageType', value: damage.damageType ? ('DAMAGES.TYPE.' + damage.damageType | translate) : null, ops: ['classification'] }"></ng-container>
            </div>
            <div class="col-md-3">
              <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Gravità', icon: 'fa-exclamation-triangle', key: 'damageSeverity', value: damage.damageSeverity ? ('DAMAGES.SEVERITY.' + damage.damageSeverity | translate) : null, ops: ['classification'] }"></ng-container>
            </div>
            <div class="col-md-3">
              <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Priorità', icon: 'fa-flag', key: 'damagePriority', value: damage.damagePriority, ops: ['classification'] }"></ng-container>
            </div>
          </div>
        </div>

        <!-- Rilevamento -->
        <div class="dd-subsection">
          <div class="dd-subsection-header">
            <span class="dd-subsection-icon"><i class="fas fa-search-location"></i></span>
            <h6 class="dd-subsection-title">Rilevamento</h6>
          </div>
          <div class="row g-3">
            <div class="col-md-3">
              <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Rilevato il', icon: 'fa-calendar-alt', key: 'damageDetectedAt', value: (damage.damageDetectedAt | date:'dd/MM/yyyy HH:mm') }"></ng-container>
            </div>
            <div class="col-md-3">
              <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Rilevato da', icon: 'fa-user', key: 'damageDetectedBy', value: userName(damage.damageDetectedBy), sub: codeNote(userName(damage.damageDetectedBy), damage.damageDetectedBy) }"></ng-container>
            </div>
            <div class="col-md-3">
              <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Fase di rilevamento', icon: 'fa-route', key: 'damageDetectedPhase', value: damage.damageDetectedPhase }"></ng-container>
            </div>
            <div class="col-md-3">
              <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Luogo', icon: 'fa-map-marker-alt', key: 'damageDetectedLocation', value: damage.damageDetectedLocation }"></ng-container>
            </div>
            <div class="col-md-3">
              <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Fonte segnalazione', icon: 'fa-bullhorn', key: 'damageSource', value: damage.damageSource }"></ng-container>
            </div>
            <div class="col-md-3">
              <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Parte responsabile', icon: 'fa-balance-scale', key: 'damageLiableParty', value: damage.damageLiableParty }"></ng-container>
            </div>
            <div class="col-md-6">
              <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Descrizione', icon: 'fa-align-left', key: 'damageDescription', value: damage.damageDescription, multiline: true }"></ng-container>
            </div>
          </div>
        </div>

        <!-- Gestione -->
        <div class="dd-subsection">
          <div class="dd-subsection-header">
            <span class="dd-subsection-icon"><i class="fas fa-tasks"></i></span>
            <h6 class="dd-subsection-title">Gestione e assegnazione</h6>
          </div>
          <div class="row g-3">
            <div class="col-md-3">
              <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Assegnata a', icon: 'fa-user-check', key: 'damageAssignedTo', value: userName(damage.damageAssignedTo), sub: codeNote(userName(damage.damageAssignedTo), damage.damageAssignedTo), ops: ['assign'] }"></ng-container>
            </div>
            <div class="col-md-3">
              <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Scadenza', icon: 'fa-calendar-check', key: 'damageDueDate', value: (damage.damageDueDate | date:'dd/MM/yyyy'), hint: isOverdue ? 'scaduta' : null, danger: isOverdue }"></ng-container>
            </div>
            <div class="col-md-3">
              <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Aperta il', icon: 'fa-calendar-plus', key: 'damageOpenedAt', value: (damage.damageOpenedAt | date:'dd/MM/yyyy HH:mm') }"></ng-container>
            </div>
            <div class="col-md-3">
              <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Aperta da', icon: 'fa-user-plus', key: 'damageOpenedBy', value: userName(damage.damageOpenedBy), sub: codeNote(userName(damage.damageOpenedBy), damage.damageOpenedBy) }"></ng-container>
            </div>
          </div>
        </div>

        <!-- Chiusura: solo per pratiche chiuse o respinte -->
        <ng-container *ngIf="isClosed || damage.damageClosedAt">
          <div class="dd-subsection">
            <div class="dd-subsection-header">
              <span class="dd-subsection-icon"><i class="fas fa-flag-checkered"></i></span>
              <h6 class="dd-subsection-title">Chiusura</h6>
            </div>
            <div class="row g-3">
              <div class="col-md-3">
                <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Chiusa il', icon: 'fa-calendar-times', key: 'damageClosedAt', value: (damage.damageClosedAt | date:'dd/MM/yyyy HH:mm') }"></ng-container>
              </div>
                <div class="col-md-3">
                <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Chiusa da', icon: 'fa-user-check', key: 'damageClosedBy', value: userName(damage.damageClosedBy), sub: codeNote(userName(damage.damageClosedBy), damage.damageClosedBy) }"></ng-container>
              </div>
                <div class="col-md-3">
                <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Esito', icon: 'fa-clipboard-check', key: 'damageCloseOutcome', value: damage.damageCloseOutcome }"></ng-container>
              </div>
                <div class="col-md-3">
                <ng-container *ngTemplateOutlet="fieldTpl; context: { label: 'Nota di chiusura', icon: 'fa-sticky-note', key: 'damageCloseNote', value: damage.damageCloseNote }"></ng-container>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Audit -->
        <div class="dd-audit mt-3">
          <span><i class="fas fa-plus-circle me-1"></i>Creata {{ damage.damageCreatedAt ? (damage.damageCreatedAt | date:'dd/MM/yyyy HH:mm') : '-' }} da {{ userName(damage.damageCreatedBy) || '-' }}</span>
          <span><i class="fas fa-pen me-1"></i>Aggiornata {{ damage.damageUpdatedAt ? (damage.damageUpdatedAt | date:'dd/MM/yyyy HH:mm') : '-' }} da {{ userName(damage.damageUpdatedBy) || '-' }}</span>
          <span *ngIf="damage.damageVersion != null"><i class="fas fa-code-branch me-1"></i>Versione {{ damage.damageVersion }}</span>
        </div>
      </div>
    </div>

    <!-- ─── SEZIONE 3: IMMAGINI ─── -->
    <!-- Immagini e documenti del collo della pratica, dall'endpoint dedicato
         /damaged-parcels/{id}/images. Card e intestazione sono della pagina; il corpo
         (griglia, lista, anteprima, download) è il componente app-damage-images,
         con lo stesso design della tab Immagini del dettaglio collo. -->
    <div class="card mb-4">
      <div class="card-header">
        <div class="d-flex justify-content-between align-items-center">
          <div class="header-title">
            <i class="fas fa-images header-icon"></i>
            <h3>Immagini</h3>
            <span class="dd-count-pill" *ngIf="imagesCount != null">{{ imagesCount }} {{ imagesCount === 1 ? 'immagine' : 'immagini' }}</span>
          </div>
          <div class="d-flex align-items-center gap-2">
            <!-- Carica un'immagine (o un PDF) sul collo della pratica: Opr_Images tipo DAMAGE, sorgente PORTAL -->
            <button type="button" class="btn btn-sm btn-primary" *ngIf="canOperate"
                    (click)="imagesSection.openFilePicker()"
                    [disabled]="imagesSection.isUploading || imagesSection.isLoading"
                    title="Carica un'immagine o un PDF del danno sul collo della pratica">
              <i class="fas" [ngClass]="imagesSection.isUploading ? 'fa-spinner fa-spin' : 'fa-upload'"></i>
              {{ imagesSection.isUploading ? 'Caricamento...' : 'Carica immagine' }}
            </button>
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="imagesSection.load()"
                    [disabled]="imagesSection.isLoading" title="Ricarica le immagini">
              <i class="fas fa-sync-alt" [class.fa-spin]="imagesSection.isLoading"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="card-body">
        <app-damage-images #imagesSection
                           [damageId]="damage.damageId"
                           [parcelCode]="damage.damageParcelCode || ''"
                           [canUpload]="canOperate"
                           (countChange)="imagesCount = $event">
        </app-damage-images>
      </div>
    </div>

    <!-- ─── SEZIONE 4: INSTRADAMENTO ─── -->
    <!-- Vista "Percorso" della tab Instradamento del dettaglio collo (senza mappa),
         dall'endpoint dedicato /damaged-parcels/{id}/routing. Card e intestazione sono della
         pagina; il corpo è il componente app-damage-routing. -->
    <div class="card mb-4">
      <div class="card-header">
        <div class="d-flex justify-content-between align-items-center">
          <div class="header-title">
            <i class="fas fa-route header-icon"></i>
            <h3>Instradamento</h3>
            <span class="dd-count-pill" *ngIf="routingCount != null">{{ routingCount }} {{ routingCount === 1 ? 'tappa' : 'tappe' }}</span>
          </div>
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="routingSection.load()"
                  [disabled]="routingSection.isLoading" title="Ricarica l'instradamento">
            <i class="fas fa-sync-alt" [class.fa-spin]="routingSection.isLoading"></i>
          </button>
        </div>
      </div>
      <div class="card-body">
        <app-damage-routing #routingSection
                            [damageId]="damage.damageId"
                            [parcel]="parcel"
                            [dealer]="dealer"
                            [canAssignLocation]="canOperate"
                            (countChange)="routingCount = $event">
        </app-damage-routing>
      </div>
    </div>

    <!-- ─── SEZIONE 5: OPERAZIONI ─── -->
    <!-- Sei riquadri (cambio stato, assegnazione, nota, nuovo importo, stato
         importo, chiusura): ognuno apre il popup dell'operazione
         (app-damage-operation-popup, stesso stile dei popup di /dealer-contacts).
         Richiedono il permesso UPDATE su damages; su una pratica chiusa restano
         solo nota e importi. A operazione conclusa il dettaglio si ricarica. -->
    <div id="operations-section" class="card mb-4">
      <div class="card-header">
        <div class="d-flex justify-content-between align-items-center">
          <div class="header-title">
            <i class="fas fa-tools header-icon"></i>
            <h3>Operazioni</h3>
          </div>
          <span class="dd-count-pill" *ngIf="!canOperate"><i class="fas fa-lock me-1"></i>Sola lettura</span>
          <span class="dd-count-pill" *ngIf="canOperate && isClosed"><i class="fas fa-lock me-1"></i>Pratica chiusa</span>
        </div>
      </div>
      <div class="card-body">

        <div class="dd-ops-notice" *ngIf="!canOperate">
          <i class="fas fa-lock"></i>
          <span>Permessi insufficienti: la pratica è consultabile ma non modificabile.</span>
        </div>

        <ng-container *ngIf="canOperate">
          <div class="dd-ops-notice dd-ops-notice--warning" *ngIf="isClosed">
            <i class="fas fa-info-circle"></i>
            <span>
              La pratica è <strong>{{ 'DAMAGES.STATUS.' + damage.damageStatus | translate }}</strong>:
              cambio stato, assegnazione e chiusura non sono più disponibili. Restano possibili note e importi.
            </span>
          </div>

          <div class="dd-ops-tiles">
            <button type="button" class="dd-op-tile"
                    *ngFor="let op of operationTiles; trackBy: trackByOperation"
                    [class.dd-op-tile--danger]="op.danger"
                    [disabled]="!op.enabled"
                    [title]="op.disabledReason || op.subtitle"
                    (click)="openOperation(op.key)">
              <span class="dmg-metric-icon dd-op-tile-icon" [ngClass]="'dmg-metric-icon--' + op.tone">
                <i class="fas" [ngClass]="op.icon"></i>
              </span>
              <span class="dd-op-tile-title">{{ op.title }}</span>
            </button>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Popup dell'operazione selezionata -->
    <app-damage-operation-popup
      [visible]="isOperationPopupVisible"
      [operation]="activeOperation"
      [damage]="damage"
      [amounts]="amounts"
      [amount]="activeAmount"
      [users]="users"
      (closed)="closeOperation()"
      (done)="onOperationDone()">
    </app-damage-operation-popup>

    <!-- ─── SEZIONE 6: IMPORTI ─── -->
    <div class="card mb-4">
      <div class="card-header">
        <div class="d-flex justify-content-between align-items-center">
          <div class="header-title">
            <i class="fas fa-euro-sign header-icon"></i>
            <h3>Importi</h3>
            <span class="dd-count-pill">{{ amounts.length }} {{ amounts.length === 1 ? 'importo' : 'importi' }}</span>
          </div>
          <div class="d-flex align-items-center gap-2">
            <ng-container *ngTemplateOutlet="opBtnTpl; context: { op: 'amount', label: true }"></ng-container>
            <ng-container *ngTemplateOutlet="opBtnTpl; context: { op: 'amountStatus', label: true }"></ng-container>
          </div>
        </div>
      </div>

      <div class="card-body" *ngIf="amounts.length === 0">
        <div class="empty-state text-center">
          <div class="empty-state-icon mb-2">
            <i class="fas fa-euro-sign fa-2x text-muted"></i>
          </div>
          <p class="empty-state-subtitle text-muted small mb-0">Nessun importo registrato per questa pratica.</p>
        </div>
      </div>

      <ng-container *ngIf="amounts.length > 0">
        <!-- Totali per tipo (esclusi gli importi annullati) -->
        <div class="card-body pb-0" *ngIf="totals.length > 0">
          <div class="dmg-metrics-grid dd-totals-grid">
            <div class="dmg-metric-card" *ngFor="let total of totals">
              <div class="dmg-metric-icon dmg-metric-icon--green">
                <i class="fas fa-coins"></i>
              </div>
              <div class="dmg-metric-body">
                <div class="dmg-metric-value">{{ total.value | number:'1.2-2' }} <small class="dd-currency">{{ currency }}</small></div>
                <div class="dmg-metric-label">Totale {{ total.type }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="table-responsive dd-amounts-wrap">
          <table class="table dmg-table mb-0">
            <thead>
              <tr>
                <th>Tipo</th>
                <th>Controparte</th>
                <th class="text-end">Importo</th>
                <th>Stato</th>
                <th>Nota</th>
                <th>Addebito</th>
                <th>Inserito il</th>
                <th>Inserito da</th>
                <th class="text-end" *ngIf="canOperate">Azioni</th>
              </tr>
            </thead>
            <tbody>
              <tr class="dmg-row" *ngFor="let amount of amounts; trackBy: trackByAmount">
                <td class="dmg-code">{{ amount.damageAmountType || '-' }}</td>
                <td>
                  {{ amount.damageAmountCounterpart || '-' }}
                  <span class="text-muted" *ngIf="amount.damageAmountCounterpartCode">({{ amount.damageAmountCounterpartCode }})</span>
                </td>
                <td class="text-end dd-amount-value" [class.dd-amount-value--cancelled]="amount.damageAmountStatus === 'CANCELLED'">
                  {{ amount.damageAmountValue != null ? (amount.damageAmountValue | number:'1.2-2') : '-' }}
                  <span class="dd-currency">{{ amount.damageAmountCurrency || currency }}</span>
                </td>
                <td>
                  <span class="dmg-badge" [ngClass]="amountStatusBadgeClass(amount.damageAmountStatus)">
                    {{ amount.damageAmountStatus ? ('DAMAGES.STATUS.' + amount.damageAmountStatus | translate) : '-' }}
                  </span>
                  <!-- Cambia lo stato di questo importo: apre "Stato importo" con la riga già selezionata -->
                  <button type="button" class="dd-field-op" *ngIf="canOperate" title="Cambia stato dell'importo"
                          (click)="openAmountOperation('amountStatus', amount)">
                    <i class="fas fa-file-invoice-dollar"></i>
                  </button>
                </td>
                <td>{{ amount.damageAmountNote || '-' }}</td>
                <td>{{ amount.damageAmountChargeId ?? '-' }}</td>
                <td class="dmg-date">{{ amount.damageAmountCreatedAt ? (amount.damageAmountCreatedAt | date:'dd/MM/yy HH:mm') : '-' }}</td>
                <td [title]="amount.damageAmountCreatedBy || ''">{{ userName(amount.damageAmountCreatedBy) || '-' }}</td>
                <!-- Modifica ed eliminazione dell'importo: aprono il popup sulla riga, entrambe tracciate in cronologia -->
                <td class="text-end text-nowrap" *ngIf="canOperate">
                  <button type="button" class="dd-field-op" title="Modifica importo"
                          (click)="openAmountOperation('amountEdit', amount)">
                    <i class="fas fa-pen"></i>
                  </button>
                  <button type="button" class="dd-field-op dd-op-btn--danger" title="Elimina importo"
                          (click)="openAmountOperation('amountDelete', amount)">
                    <i class="fas fa-trash-alt"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
    </div>

    <!-- ─── SEZIONE 7: CRONOLOGIA EVENTI ─── -->
    <!-- Paginata lato backend (GET /{id}/events) con elementi per pagina a scelta;
         vista estesa (timeline) o compatta (tabella), preferenze ricordate nel browser. -->
    <div class="card">
      <div class="card-header">
        <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
          <div class="header-title">
            <i class="fas fa-stream header-icon"></i>
            <h3>Cronologia</h3>
            <span class="dd-count-pill">{{ timelineTotal }} {{ timelineTotal === 1 ? 'evento' : 'eventi' }}</span>
          </div>
          <div class="d-flex align-items-center gap-2 flex-wrap">
            <!-- Vista estesa / compatta -->
            <div class="btn-group btn-group-sm pagination-selector" role="group" title="Modalità di visualizzazione">
              <button type="button" class="btn" [ngClass]="!timelineCompact ? 'btn-secondary' : 'btn-outline-secondary'"
                      (click)="setTimelineCompact(false)" title="Vista estesa">
                <i class="fas fa-stream"></i>
              </button>
              <button type="button" class="btn" [ngClass]="timelineCompact ? 'btn-secondary' : 'btn-outline-secondary'"
                      (click)="setTimelineCompact(true)" title="Vista compatta">
                <i class="fas fa-list"></i>
              </button>
            </div>
            <!-- Ordine -->
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="toggleTimelineOrder()"
                    [title]="timelineNewestFirst ? 'Dal più recente: clicca per dal più vecchio' : 'Dal più vecchio: clicca per dal più recente'">
              <i class="fas" [ngClass]="timelineNewestFirst ? 'fa-sort-amount-down' : 'fa-sort-amount-up-alt'"></i>
            </button>
            <!-- Elementi per pagina -->
            <div class="btn-group btn-group-sm pagination-selector" role="group" title="Eventi per pagina">
              <button type="button" class="btn" *ngFor="let n of timelinePageSizeOptions"
                      [ngClass]="timelinePageSize === n ? 'btn-secondary' : 'btn-outline-secondary'"
                      (click)="setTimelinePageSize(n)" [title]="n + ' eventi per pagina'">
                {{ n }}
              </button>
            </div>
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="loadTimeline()"
                    [disabled]="isTimelineLoading" title="Ricarica la cronologia">
              <i class="fas fa-sync-alt" [class.fa-spin]="isTimelineLoading"></i>
            </button>
            <ng-container *ngTemplateOutlet="opBtnTpl; context: { op: 'note', label: true }"></ng-container>
          </div>
        </div>
      </div>
      <div class="card-body" [class.dd-timeline-loading]="isTimelineLoading">
        <div class="empty-state text-center" *ngIf="timelineError">
          <div class="empty-state-icon mb-2">
            <i class="fas fa-exclamation-circle fa-2x text-danger"></i>
          </div>
          <p class="empty-state-subtitle text-muted small mb-2">{{ timelineError }}</p>
          <button type="button" class="btn btn-primary btn-sm" (click)="loadTimeline()">
            <i class="fas fa-redo-alt me-1"></i> Riprova
          </button>
        </div>

        <div class="empty-state text-center" *ngIf="!timelineError && timelineTotal === 0 && !isTimelineLoading">
          <div class="empty-state-icon mb-2">
            <i class="fas fa-stream fa-2x text-muted"></i>
          </div>
          <p class="empty-state-subtitle text-muted small mb-0">Nessun evento registrato per questa pratica.</p>
        </div>

        <!-- Vista compatta: una riga per evento -->
        <div class="table-responsive dd-timeline-compact" *ngIf="timelineCompact && timelineEvents.length > 0">
          <table class="table dmg-table mb-0">
            <thead>
              <tr>
                <th class="text-end">#</th>
                <th>Data</th>
                <th>Evento</th>
                <th>Stato</th>
                <th>Utente</th>
                <th>Canale</th>
                <th>Nota / riferimento</th>
              </tr>
            </thead>
            <tbody>
              <tr class="dmg-row" *ngFor="let ev of timelineEvents; let i = index; trackBy: trackByEvent">
                <td class="text-end text-muted">{{ timelineIndex(i) }}</td>
                <td class="dmg-date text-nowrap">{{ ev.damageEventAt ? (ev.damageEventAt | date:'dd/MM/yy HH:mm') : '-' }}</td>
                <td class="text-nowrap">
                  <span class="dd-compact-icon" [ngClass]="eventClass(ev.damageEventType)"><i class="fas" [ngClass]="eventIcon(ev.damageEventType)"></i></span>
                  {{ ev.damageEventType ? ('DAMAGES.EVENT_TYPE.' + ev.damageEventType | translate) : '-' }}
                </td>
                <td class="text-nowrap">
                  <ng-container *ngIf="ev.damageEventStatusTo; else noStatus">
                    <ng-container *ngIf="ev.damageEventStatusFrom">{{ 'DAMAGES.STATUS.' + ev.damageEventStatusFrom | translate }} <i class="fas fa-arrow-right dd-compact-arrow"></i> </ng-container>
                    {{ 'DAMAGES.STATUS.' + ev.damageEventStatusTo | translate }}
                  </ng-container>
                  <ng-template #noStatus>-</ng-template>
                </td>
                <td [title]="ev.damageEventBy || ''">{{ userName(ev.damageEventBy) || '-' }}</td>
                <td class="text-muted">{{ ev.damageEventChannel || '-' }}</td>
                <td class="dd-compact-note" [title]="ev.damageEventNote || ''">
                  {{ ev.damageEventNote || '-' }}
                  <span class="text-muted" *ngIf="ev.damageEventRefType"> ({{ ev.damageEventRefType }} {{ ev.damageEventRefId }})</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Vista estesa: timeline -->
        <ul class="dd-timeline" *ngIf="!timelineCompact && timelineEvents.length > 0">
          <li class="dd-timeline-item" *ngFor="let ev of timelineEvents; trackBy: trackByEvent">
            <div class="dd-timeline-icon" [ngClass]="eventClass(ev.damageEventType)">
              <i class="fas" [ngClass]="eventIcon(ev.damageEventType)"></i>
            </div>
            <div class="dd-timeline-body">
              <div class="dd-timeline-head">
                <span class="dd-timeline-type">
                  {{ ev.damageEventType ? ('DAMAGES.EVENT_TYPE.' + ev.damageEventType | translate) : '-' }}
                </span>
                <span class="dd-timeline-status" *ngIf="ev.damageEventStatusTo">
                  <ng-container *ngIf="ev.damageEventStatusFrom">
                    {{ 'DAMAGES.STATUS.' + ev.damageEventStatusFrom | translate }}
                    <i class="fas fa-arrow-right"></i>
                  </ng-container>
                  {{ 'DAMAGES.STATUS.' + ev.damageEventStatusTo | translate }}
                </span>
                <span class="dd-timeline-date">
                  <i class="far fa-clock me-1"></i>{{ ev.damageEventAt ? (ev.damageEventAt | date:'dd/MM/yyyy HH:mm') : '-' }}
                </span>
              </div>
              <div class="dd-timeline-meta">
                <span [title]="ev.damageEventBy || ''"><i class="fas fa-user me-1"></i>{{ userName(ev.damageEventBy) || '-' }}</span>
                <span *ngIf="ev.damageEventActorType"><i class="fas fa-id-badge me-1"></i>{{ ev.damageEventActorType }}</span>
                <span *ngIf="ev.damageEventChannel"><i class="fas fa-plug me-1"></i>{{ ev.damageEventChannel }}</span>
                <span *ngIf="ev.damageEventRefType"><i class="fas fa-link me-1"></i>{{ ev.damageEventRefType }} {{ ev.damageEventRefId }}</span>
              </div>
              <p class="dd-timeline-note" *ngIf="ev.damageEventNote">{{ ev.damageEventNote }}</p>
            </div>
          </li>
        </ul>

        <!-- Paginazione (stesso stile di /damage-overview) -->
        <div class="pagination-container dd-timeline-pagination" *ngIf="timelineTotal > 0 && !timelineError">
          <div class="pagination-controls">
            <button class="pagination-btn" (click)="onTimelinePageChange(1)"
                    [disabled]="timelinePage === 1" aria-label="Prima pagina" title="Prima pagina">
              <i class="fas fa-angles-left"></i>
            </button>
            <button class="pagination-btn" (click)="onTimelinePageChange(timelinePage - 1)"
                    [disabled]="timelinePage === 1" aria-label="Precedente" title="Precedente">
              <i class="fas fa-chevron-left"></i>
            </button>
            <div class="page-numbers">
              <ng-container *ngFor="let page of getTimelinePageItems(); trackBy: trackByPageItem">
                <span class="pagination-ellipsis" *ngIf="page === null">…</span>
                <button *ngIf="page !== null" class="pagination-number" [class.active]="page === timelinePage"
                        (click)="onTimelinePageChange(page)" [attr.aria-label]="'Pagina ' + page" [title]="'Vai alla pagina ' + page">
                  {{ page }}
                </button>
              </ng-container>
            </div>
            <span class="pagination-info">{{ timelineRangeStart }} - {{ timelineRangeEnd }} di {{ timelineTotal }}</span>
            <button class="pagination-btn" (click)="onTimelinePageChange(timelinePage + 1)"
                    [disabled]="timelinePage === timelineTotalPages" aria-label="Successivo" title="Successivo">
              <i class="fas fa-chevron-right"></i>
            </button>
            <button class="pagination-btn" (click)="onTimelinePageChange(timelineTotalPages)"
                    [disabled]="timelinePage === timelineTotalPages" aria-label="Ultima pagina" title="Ultima pagina">
              <i class="fas fa-angles-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<!-- Campo in sola lettura della sezione "Pratica Danno": etichetta, icona,
     valore (trattino se vuoto) e bottone di copia negli appunti con spunta
     verde di conferma per 1,5s (stesso bottone delle celle di /damaged-parcels). -->
<ng-template #fieldTpl let-label="label" let-icon="icon" let-key="key" let-value="value"
             let-mono="mono" let-multiline="multiline" let-hint="hint" let-danger="danger" let-sub="sub" let-ops="ops">
  <div class="dd-field" [class.dd-field--danger]="danger">
    <span class="dd-field-label">{{ label }}</span>
    <div class="dd-field-value"
         [class.dd-field-value--mono]="mono"
         [class.dd-field-value--multiline]="multiline"
         [class.dd-field-value--empty]="value == null || value === ''">
      <i class="fas dd-field-icon" [ngClass]="icon"></i>
      <span class="dd-field-text">
        {{ (value == null || value === '') ? '-' : value }}
        <span class="dd-field-sub" *ngIf="sub">{{ sub }}</span>
      </span>
      <span class="dd-field-hint" *ngIf="hint">{{ hint }}</span>
      <button type="button" class="dmg-copy-btn dd-copy-btn"
              *ngIf="value != null && value !== ''"
              [title]="isCopied(key) ? 'Copiato!' : 'Copia ' + label"
              (click)="copyValue(key, value)">
        <i class="fas" [ngClass]="isCopied(key) ? 'fa-check' : 'fa-copy'"></i>
      </button>
      <!-- Operazioni collegate al campo (es. Stato: cambio stato e chiusura): aprono lo stesso popup dei riquadri -->
      <ng-container *ngFor="let op of ops || []">
        <ng-container *ngTemplateOutlet="opBtnTpl; context: { op: op }"></ng-container>
      </ng-container>
    </div>
  </div>
</ng-template>

<!-- Bottone che apre il popup di un'operazione: a sola icona nei campi, con etichetta
     nelle intestazioni (label). Compare solo se l'operazione è disponibile. -->
<ng-template #opBtnTpl let-op="op" let-label="label">
  <ng-container *ngIf="operationTile(op) as tile">
    <button type="button"
            [class]="label ? 'btn btn-sm btn-primary dd-op-btn' : 'dd-field-op'"
            [class.dd-op-btn--danger]="tile.danger"
            [title]="tile.subtitle"
            (click)="openOperation(op)">
      <i class="fas" [ngClass]="tile.icon"></i>
      <ng-container *ngIf="label"><span class="ms-1">{{ tile.title }}</span></ng-container>
    </button>
  </ng-container>
</ng-template>
